import { render, staticRenderFns } from "./ModalPresupuestoGestion.vue?vue&type=template&id=ec050e1a"
import script from "./ModalPresupuestoGestion.vue?vue&type=script&lang=js"
export * from "./ModalPresupuestoGestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports